// Import model
import { FilterLaminatesCatalogItemRequest } from '../models/FilterLaminatesCatalogItemRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { LaminatesCatalogItemCondition } from '../models/LaminatesCatalogItemCondition';
import { LaminatesCatalogItemFields } from '../models/LaminatesCatalogItemFields';
import { LaminatesCatalogItemIndexedFields } from '../models/LaminatesCatalogItemIndexedFields';

// Import dependency serializers (for complex types)
import { LaminatesCatalogItemConditionSerializer } from './LaminatesCatalogItemConditionSerializer';
import { LaminatesCatalogItemFieldsSerializer } from './LaminatesCatalogItemFieldsSerializer';
import { LaminatesCatalogItemIndexedFieldsSerializer } from './LaminatesCatalogItemIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterLaminatesCatalogItemRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterLaminatesCatalogItemRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterLaminatesCatalogItemRequest instance
   */
  static deserialize(json: string): FilterLaminatesCatalogItemRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterLaminatesCatalogItemRequest instance
   */
  static fromObject(obj: any): FilterLaminatesCatalogItemRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterLaminatesCatalogItemRequest');
    }


    const instance: FilterLaminatesCatalogItemRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as LaminatesCatalogItemIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as LaminatesCatalogItemFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        LaminatesCatalogItemConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterLaminatesCatalogItemRequest instances
   */
  static deserializeArray(json: string): FilterLaminatesCatalogItemRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterLaminatesCatalogItemRequest instance to a JSON string
   */
  static serialize(instance: FilterLaminatesCatalogItemRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterLaminatesCatalogItemRequest instance to a plain object
   */
  static toObject(instance: FilterLaminatesCatalogItemRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        LaminatesCatalogItemConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterLaminatesCatalogItemRequest instances to a JSON string
   */
  static serializeArray(instances: FilterLaminatesCatalogItemRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
